import { render, staticRenderFns } from "./XueYang.vue?vue&type=template&id=0e28256a&scoped=true&"
import script from "./XueYang.vue?vue&type=script&lang=js&"
export * from "./XueYang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e28256a",
  null
  
)

export default component.exports